import React from 'react';
import ViewContainer from '@loggi/ui/components/view-container';
import Col from '@loggi/ui/components/col';
import Icon from '@loggi/ui/components/icon';
import colors from '@loggi/ui/components/utils/colors';

function SearchValue({ value, multi, onClear }) {
  const style = {
    backgroundColor: colors.hex[colors.type.ACTIVE_LIGHTER],
    color: colors.hex[colors.type.ACTIVE_DARKER]
  };

  const clearStyle = {
    cursor: 'pointer',
    textAlign: 'right'
  };

  if (!value.length) {
    return null;
  }

  return (
    <ViewContainer className="text-sm" style={style}>
      <Col
        size={12}
        gutter={{
          left: 'normal',
          right: 'normal',
          top: 'half',
          bottom: 'half'
        }}
      >
        <ViewContainer>
          <Col size={10}>
            <strong>Selecionado: </strong> {value[0].label}
          </Col>
          <Col size={2} style={clearStyle} onMouseDown={onClear}>
            <Icon type="wrong" />
          </Col>
        </ViewContainer>
      </Col>
    </ViewContainer>
  );
}

SearchValue.displayName = 'SearchValue';
export default SearchValue;
